import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';

export class InlineImageLoader extends Component {
    static propTypes = {
        isInlineImageLoading: PropTypes.bool,
        inlineLoaderClass: PropTypes.string,
    };

    static defaultProps = {
        isInlineImageLoading: false,
        inlineLoaderClass: '',
    };

    shouldComponentUpdate(nextProps) {
        return this.props.isInlineImageLoading !== nextProps.isInlineImageLoading;
    }

    render() {
        return this.props.isInlineImageLoading ? (
            <Loader
                loaderClass={this.props.inlineLoaderClass}
                automationId="test-automation-loader-1"
            />
        ) : null;
    }
}

const mapStateToProps = (state) => ({
    isInlineImageLoading: state.isInlineImageLoading,
});

export default connect(mapStateToProps)(InlineImageLoader);
